<template>
  <table class="el-table fields-table">
    <thead>
    <tr>
      <th style="width:36px;"></th>
      <th>Название</th>
      <th>Тип</th>
      <th style="width:60px;">Обяз.</th>
      <th style="width:120px;">Действия</th>
    </tr>
    </thead>
    <tbody v-if="dragList.length === 0">
    <tr>
      <td colspan="5" class="empty-row">
        Нет пользовательских полей
      </td>
    </tr>
    </tbody>
    <draggable
      v-else
      v-model="dragList"
      item-key="id"
      handle=".drag-handle"
      tag="tbody"
      @end="onDragEnd"
    >
      <template #item="{element}">
        <tr>
          <td><span class="drag-handle">⠿</span></td>
          <td>{{ element.label }}</td>
          <td>{{ TYPE_LABELS[element.type] || element.type }}</td>
          <td class="center">{{ element.required ? 'Да' : 'Нет' }}</td>
          <td>
            <el-button :icon="Edit" size="small" type="primary" circle @click="handleEdit(element)"/>
            <el-button :icon="Delete" size="small" type="danger" circle @click="handleDelete(element)"/>
          </td>
        </tr>
      </template>
    </draggable>
  </table>
</template>

<script>
import draggable from 'vuedraggable'
import { ElMessageBox } from 'element-plus'
import { Delete, Edit } from '@element-plus/icons-vue'
export default {
  name: 'CustomFieldsTable',
  computed: {
    Delete() {
      return Delete
    },
    Edit() {
      return Edit
    }
  },
  components: { draggable },
  props: {
    fields: { type: Array, required: true },
    entity: { type: String, required: true }
  },
  emits: ['remove', 'edit', 'update:fields'],
  data() {
    return {
      dragList: [],
      TYPE_LABELS: {
        text: 'Текст',
        number: 'Число',
        select: 'Список',
        multiselect: 'Мультисписок',
        radio: 'Переключатель',
        checkbox: 'Чекбокс',
        date: 'Дата',
        datetime: 'Дата+время',
        textarea: 'Многострочный текст',
        switch: 'Переключатель',
        slider: 'Ползунок',
        // и другие типы если нужно
      }
    }
  },
  watch: {
    fields: {
      handler: 'updateDragList',
      immediate: true,
      deep: true
    },
    entity: {
      handler: 'updateDragList',
      immediate: true
    }
  },
  methods: {
    updateDragList() {
      this.dragList = this.fields.filter(f => f.entity === this.entity)
    },
    onDragEnd() {
      // Собираем новый порядок для текущей entity
      const sorted = this.dragList.map((f, idx) => ({
        id: f.id,
        sort: idx + 1
      }))
      // Диспатчим экшен в стор
      this.$store.dispatch('custom_fields/updateSortCustomFields', sorted)
    },
    handleDelete(field) {
      ElMessageBox.confirm(
        `Вы уверены, что хотите удалить поле "<b>${field.label}</b>"?`,
        'Подтвердите удаление',
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: 'Удалить',
          cancelButtonText: 'Отмена',
          type: 'warning'
        }
      ).then(() => {
        this.$emit('remove', field)
      }).catch(() => {})
    },
    handleEdit(field) {
      this.$emit('edit', field)
    },
  }
}
</script>

<style scoped>
.el-table {
  width: 100%;
  min-width: 620px;
  border-collapse: separate;
  border-spacing: 0;
  background: #08172f;
  font-size: 15px;
  border: 1px solid rgba(110, 146, 214, 0.16);
  border-radius: 16px;
  overflow: hidden;
}
.el-table th,
.el-table td {
  padding: 8px 12px;
  border-bottom: 1px solid rgba(174, 194, 230, 0.1);
  text-align: left;
  vertical-align: middle;
  color: #d7e7ff;
}
.el-table th {
  background: #0e2447;
  font-weight: 600;
  color: rgba(174, 194, 230, 0.74);
  font-size: 11px;
  letter-spacing: 0.8px;
  text-transform: uppercase;
}
.el-table tr:last-child td {
  border-bottom: none;
}

.el-table tr {
  background: #08172f;
}

.el-table tr:hover td {
  background: rgba(0, 195, 254, 0.05);
}

.drag-handle {
  cursor: grab;
  color: rgba(174, 194, 230, 0.6);
  font-size: 18px;
  transition: color 0.2s;
  user-select: none;
}
.drag-handle:hover {
  color: #22c0ff;
}
.center {
  text-align: center;
}

.empty-row {
  text-align: center;
  color: rgba(174, 194, 230, 0.68);
  font-size: 16px;
  padding: 32px 0;
  background: #08172f;
}

:deep(.el-button) {
  border-radius: 10px;
}

:deep(.el-button--primary) {
  border: none;
  background: linear-gradient(135deg, #22c0ff, #2b7cff);
}
</style>
